import {
  SOLAR_DEFAULT_VARIANT,
  SOLAR_ICON_NAME_SET,
  SOLAR_ICON_VARIANT_OVERRIDES,
  SOLAR_SPRITE_BASE_PATH,
  SOLAR_SPRITE_VERSION,
} from '../../../../icons/generated/solar-icon-names';

export const resolveSolarIconHref = (icon: string): string => {
  if (!icon || !SOLAR_ICON_NAME_SET.has(icon)) return '';

  const variant = SOLAR_ICON_VARIANT_OVERRIDES.get(icon) ?? SOLAR_DEFAULT_VARIANT;
  const base = variant === SOLAR_DEFAULT_VARIANT ? icon : icon.slice(0, -variant.length - 1);

  return `${SOLAR_SPRITE_BASE_PATH}/solar-${variant}.svg?v=${SOLAR_SPRITE_VERSION}#${base}-${variant}`;
};
